import React, {useEffect} from 'react';
import './Signup.scss';
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import {useAuth0} from "../../utils/providers/Auth0Provider";
import {navigate} from "@reach/router";


function Signup(props) {
  const { loginWithRedirect, loginWithPopup, loading, isAuthenticated } = useAuth0();
  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        navigate("/vaults");
      } else {
        loginWithRedirect({screen_hint: 'signup'});
      }
    }
  }, [loading])

  return (
    <div className="full-size"/>
  );
};

export default compose(
  connect(
    null,
    { toggleLoading }
  )
)(Signup);
